import PropTypes from 'prop-types';
import React from 'react';
import AddAppSiteButton from '../AddAppSiteButton';
import AppSitesTable from '../AppSitesTable';
import PageHeader from '../PageHeader';
import { partnerShape } from '../types';
import css from './BasePartnerAppSitesSummary.css';

export const SUMMARY_DATA_TEST_ID = 'app-sites-summary';

export default function BasePartnerAppSitesSummary({
    partner,
    filter = '',
    onAppSiteForPartner = () => {},
    canAddAppSite = false,
}) {
    return (
        <div className={css.appSitesSummary} data-testid={SUMMARY_DATA_TEST_ID}>
            <PageHeader partner={partner} />
            {canAddAppSite && (
                <AddAppSiteButton
                    className={css.addAppSiteButton}
                    partner={partner}
                    onAddAppSite={onAppSiteForPartner}
                />
            )}
            <AppSitesTable filter={filter} partner={partner} onAppSiteForPartner={onAppSiteForPartner} />
        </div>
    );
}

BasePartnerAppSitesSummary.propTypes = {
    partner: partnerShape.isRequired,
    filter: PropTypes.string,
    onAppSiteForPartner: PropTypes.func,
    canAddAppSite: PropTypes.bool,
};
